import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { OrderIntakeStep } from "../features/order-intake";
import AppWrapper from '../shared/components/layout/AppWrapper';
import DesignLayout from '../shared/components/layout/DesignLayout';
import { ToastContainer } from 'react-toastify';
import { AuthProvider, useAuth } from '../shared/contexts/AuthContext';
import Login from '../shared/components/layout/Login';
import { designChildRoutes } from './router';
import './App.css';

const LegacyProcessOverviewRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/dashboard${search}`} replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/dashboard" />} />
    <Route path="/dashboard" element={<OrderIntakeStep />} />
    <Route path="/dashboard/processes" element={<LegacyProcessOverviewRedirect />} />
    <Route path="/design" element={<DesignLayout />}>
      {designChildRoutes}
    </Route>
    <Route path="*" element={<Navigate to="/dashboard" />} />
  </Routes>
);

const AppContent = () => {
  const { isLoggedIn, login, loginRequired } = useAuth();

  if (!loginRequired) {
    return (
      <AppWrapper>
        <AppRoutes />
      </AppWrapper>
    );
  }

  if (!isLoggedIn) {
    return <Login onLoginSuccess={login} />;
  }

  return (
    <AppWrapper>
      <AppRoutes />
    </AppWrapper>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
        <ToastContainer position="bottom-center" autoClose={3000} hideProgressBar={false} newestOnTop={true} closeOnClick pauseOnFocusLoss pauseOnHover/>
      </AuthProvider>
    </Router>
  );
}

export default App;
